export interface TipoDeIncidencia {
  id: number;
  value: string;
  idInterno: number;
};

//Si se introduce un comentario manualmente en el invoicer (escribiendo en el campo observaciones de cliente) se asignara el idInterno 20
//para que no llegue a 0 y cargue el texto de incidencia en el otro lado

export const TiposDeIncidenciasEnum: TipoDeIncidencia[] = [
  {
    id: 0,
    value: '',
    idInterno: 0
  },
  {
    id: 1,
    value: 'El documento no es una factura',
    idInterno: 100
  },
  {
    id: 2,
    value: 'El documento es ilegible',
    idInterno: 101
  }, {
    id: 3,
    value: 'No es posible identificar la fecha de la factura',
    idInterno: 1
  }, {
    id: 4,
    value: 'No es posible identificar el cliente o proveedor de la factura',
    idInterno: 2
  }, {
    id: 5,
    value: 'No es posible identificar los valores del documento',
    idInterno: 3
  }, {
    id: 6,
    value: 'El documento es más de una factura',
    idInterno: 102
  }, {
    id: 8,
    value: 'Factura duplicada',
    idInterno: 103
  }, {
    id: 9,
    value: 'La factura no corresponde al cliente',
    idInterno: 104
  },
  {
    id: 11,
    value: 'Revisar Fecha',
    idInterno: 6
  }, {
    id: 12,
    value: 'Revisar Fecha e importes',
    idInterno: 7
  }, {
    id: 13,
    value: 'Revisar Bases',
    idInterno: 8
  },
  {
    id: 15,
    value: 'Revisar tipo de retención',
    idInterno: 10
  }, {
    id: 16,
    value: 'No desglosado I.V.A. en factura',
    idInterno: 11
  },
  {
    id: 19,
    value: 'Revisar tipo de factura',
    idInterno: 14
  },
  {
    id: 20,
    value: 'Importes en una moneda diferente al euro',
    idInterno: 15
  },
  {
    id: 21,
    value: 'No cumple los criterios de DIEZSCAN',
    idInterno: 105
  },
  {
    id: 22,
    value: 'El documento puede no ser una factura',
    idInterno: 16
  },
  {
    id: 7,
    value: 'Otros',
    idInterno: 99
  }

];
